import Http from '@/services/Http';

const path = '/bird-id';

const client = new Http(path);

client.getToken = (data) => client.post(data);

export default client;
